/**
 * Whether what was typed is the agent's name exactly, ignoring surrounding
 * whitespace, gating the delete the way S3 gates bucket deletion.
 * Case-sensitive, as Kumo's `DeleteResource` is by default.
 */
export function isDeleteConfirmed(typed: string, agentName: string): boolean {
  return typed.trim() === agentName;
}
